/* Quick add on product cards — Elleroué
   Adds a variant straight to the cart and re-renders Dawn's cart drawer,
   mirroring the fetch flow in product-form.js. */

if (!customElements.get('quick-add-elle')) {
  customElements.define(
    'quick-add-elle',
    class QuickAddElle extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', this.onClick.bind(this));
      }

      connectedCallback() {
        if (!QuickAddElle.documentListenerAdded) {
          document.addEventListener('click', (event) => {
            document.querySelectorAll('quick-add-elle.is-open').forEach((element) => {
              if (!element.contains(event.target)) element.close();
            });
          });
          document.addEventListener('keyup', (event) => {
            if (event.key !== 'Escape') return;
            document.querySelectorAll('quick-add-elle.is-open').forEach((element) => element.close());
          });
          document.addEventListener('click', (event) => {
            const swatch = event.target.closest('a[data-card-swatch][data-color]');
            if (!swatch) return;
            const card = swatch.closest('.card-wrapper');
            const quickAdd = card && card.querySelector('quick-add-elle');
            if (quickAdd) quickAdd.setColor(swatch.dataset.color);
          });
          QuickAddElle.documentListenerAdded = true;
        }
      }

      get cart() {
        return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      }

      onClick(event) {
        const button = event.target.closest('.qae__action, .qae__toggle');
        if (!button) return;
        if (button.classList.contains('qae__add--link')) return;

        event.preventDefault();
        event.stopPropagation();

        if (button.hasAttribute('disabled') || button.classList.contains('is-loading')) return;

        if (button.dataset.variantId) {
          this.addToCart(button.dataset.variantId, button);
        } else {
          this.toggle();
        }
      }

      toggle() {
        this.classList.contains('is-open') ? this.close() : this.open();
      }

      open() {
        document.querySelectorAll('quick-add-elle.is-open').forEach((element) => {
          if (element !== this) element.close();
        });
        this.classList.add('is-open');
        this.setToggleState(true);
      }

      close() {
        this.classList.remove('is-open');
        this.setToggleState(false);
      }

      /* Keeps the "+" and the single/options behaviour pointed at the colour
         the shopper just picked on the card's farve-swatch. */
      setColor(color) {
        if (!color || this.dataset.activeColor === color) return;
        this.dataset.activeColor = color;
        this.close();

        const bar = this.querySelector(`.qae__bar[data-color="${color}"]`);
        if (!bar) return;

        const single = bar.dataset.single === 'true';
        this.classList.toggle('qae--single', single);

        const toggle = this.querySelector('.qae__toggle');
        if (!toggle) return;

        const add = bar.querySelector('.qae__add[data-variant-id]');
        if (single && add) {
          toggle.dataset.variantId = add.dataset.variantId;
        } else {
          delete toggle.dataset.variantId;
        }
      }

      setToggleState(open) {
        const toggle = this.querySelector('.qae__toggle');
        if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      addToCart(variantId, button) {
        const cart = this.cart;
        const config =
          typeof fetchConfig === 'function'
            ? fetchConfig('javascript')
            : { method: 'POST', headers: { Accept: 'application/javascript' } };

        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', 1);

        if (cart) {
          formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(button);
        }

        config.body = formData;
        button.classList.add('is-loading');
        button.setAttribute('aria-disabled', 'true');

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.onError(button, response.description || response.message);
              return;
            }

            if (!cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'quick-add-elle',
                productVariantId: variantId,
                cartData: response,
              });
            }

            this.onSuccess(button);
            cart.classList.remove('is-empty');
            cart.renderContents(response);
          })
          .catch((error) => {
            console.error(error);
            this.onError(button);
          })
          .finally(() => {
            button.classList.remove('is-loading');
            button.removeAttribute('aria-disabled');
          });
      }

      onSuccess(button) {
        this.close();
        button.classList.add('is-added');
        clearTimeout(this.addedTimeout);
        this.addedTimeout = setTimeout(() => button.classList.remove('is-added'), 1800);
      }

      onError(button, message) {
        button.classList.add('qae__action--error');
        setTimeout(() => button.classList.remove('qae__action--error'), 2000);
        if (message) console.warn(`[quick add] ${message}`);
      }
    }
  );
}
